import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import {WeaNewScroll} from 'ecCom';
import IntroStep1 from './portalintro/IntroStep1';

@inject('portalThemeStore')
@observer
class E9TopMenu extends React.Component {
    constructor(props) {
        super(props);
        this.onVisibleChange = this.onVisibleChange.bind(this);
        this.onTopMenuClick = this.onTopMenuClick.bind(this);
        this.state = {
            textmenuHeight: jQuery(document.body).height() - 10,
        }
    }
    resetHeigth(){
        const trueh=$('.e9header-top-menu2-items').height();
        const containerh=$('.e9theme-layout-container').height();
        if(trueh>containerh){
            this.setState({textmenuHeight:jQuery(document.body).height() - 10});
        }else{
            this.setState({textmenuHeight:trueh});
        }
    }
    componentDidMount(){
    	jQuery(window).resize(() => {
		    this._reactInternalInstance !== undefined && this.resetHeigth();
        });   
    }

    componentDidUpdate(){
        const trueh=$('.e9header-top-menu2-items').height();
        const containerh=$('.e9theme-layout-container').height();
        if(trueh>containerh){
            $('#topMenutextScroll').css({height:jQuery(document.body).height() - 10})
        }else{
            $('#topMenutextScroll').css({height:trueh})
        }
    }


    render() {
        const {portalThemeStore} = this.props;
        const {textmenuHeight} = this.state;
        const {topMenuObj, topMenuVisible} = portalThemeStore;
        const {topMenu = [], topMenuSelected = {}} = topMenuObj;
        const _topMenu = toJS(topMenu);
        const _topMenuSelected = toJS(topMenuSelected);
        const {id: selectedId} = _topMenuSelected;

        const {themeInfo} = portalThemeStore;
        const {themeData = {}} = themeInfo;
        const {styleConfig = {}} = themeData;
        const {topmenu = {}} = styleConfig;
        const { showCount = 6 } = topmenu;
        if (topmenu.style == 'text') {
            return (
                <div className={`e9header-top-menu2 ${topMenuVisible ? 'e9header-top-menu2-open' : ''}`} onMouseLeave={() => this.onVisibleChange(false)}>
                    <div className="e9header-top-menu2-content" style={{maxWidth:showCount*60+35+'px'}}>
                    {topMenuVisible ? 
                    <div>
                            <WeaNewScroll height={textmenuHeight} scrollId={'topMenutextScroll'}>
                                <div className="e9header-top-menu2-items" style={{maxWidth:showCount*60+'px'}}>
                                    {
                                        _topMenu.map((item, index) => {
                                            const {id, name} = item;
                                            const selected = id == selectedId;

                                            return (
                                                <div key={index}
                                                    data-id={id}
                                                    className={`e9header-top-menu2-item ${selected ? 'e9header-top-menu2-item-selected' : ''}`}
                                                    title={item.name}
                                                    onClick={() => this.onTopMenuClick(item)}
                                                >
                                                    {name}
                                                </div>
                                            );
                                        })
                                    }
                                    <div style={{clear: 'both'}}/>
                                </div>
                                {topMenu.length > showCount && (
                                    <div className="e9header-top-menu2-btn" onClick={() => this.onVisibleChange(!topMenuVisible)}>
                                        <i className="icon-coms-List"/>
                                    </div>
                                )}
                            </WeaNewScroll>
                                <div style={{clear: 'both'}}/>
                     </div>
                     :
                     <div>
                            <div className="e9header-top-menu2-items" style={{maxWidth:showCount*60+'px'}}>
                                {
                                    _topMenu.map((item, index) => {
                                        const {id, name} = item;
                                        const selected = id == selectedId;

                                        return (
                                            <div key={index}
                                                data-id={id}
                                                className={`e9header-top-menu2-item ${selected ? 'e9header-top-menu2-item-selected' : ''}`}
                                                title={item.name}
                                                onClick={() => this.onTopMenuClick(item)}
                                            >
                                                {name}
                                            </div>
                                        );
                                    })
                                }
                                <div style={{clear: 'both'}}/>
                            </div>
                            {topMenu.length > showCount && (
                                <div className="e9header-top-menu2-btn" onClick={() => this.onVisibleChange(!topMenuVisible)}>
                                    <i className="icon-coms-List"/>
                                </div>
                            )}
                     <div style={{clear: 'both'}}/>
                     </div>
                     }
                   
                    </div>
                </div>
            );
        }

        return (
            <div className="e9header-top-menu">
                <IntroStep1/>
            </div>
        );
    }

    onVisibleChange(visible) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onTopMenuVisibleChange(visible);
    }

    onTopMenuClick(topMenuSelected) {
        this.onVisibleChange(false);

        const {portalThemeStore} = this.props;
        portalThemeStore.onTopMenuSelectedChange(topMenuSelected);
    }
}

export default E9TopMenu;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/E9TopMenu.js